import { CheckCircle } from "lucide-react";
import { Link } from "react-router-dom";

export const PaymentSuccess = () => (
  <div className="min-h-screen bg-gradient-to-b from-[#1a1a1a] to-black text-white flex items-center justify-center">
    <div className="glass-card p-12 max-w-md mx-4 text-center">
      <CheckCircle className="w-16 h-16 text-green-400 mx-auto mb-6" />
      <h1 className="text-3xl font-bold mb-4">Payment Successful!</h1>
      <p className="text-gray-300 mb-8">
        Your promotion credits have been added to your account. Head back to the
        chat to start promoting your events.
      </p>
      <Link
        to="/app"
        className="inline-block bg-white text-black font-semibold px-8 py-3 rounded-full hover:bg-gray-200 transition-colors"
      >
        Go to App
      </Link>
    </div>
  </div>
);
